import { bookingState } from "./BookingState";
import { getCustomerId, getCurrentBooking, bookCar, apiCancelBooking } from "./Api";
import { get } from "svelte/store";

export async function refreshBooking() {
  let { token } = get(bookingState);

  if (!token) {
    return; // not logged in
  }

  // get user’s customerId
  const id = await getCustomerId(token);
  if (!id) {
    bookingState.update((s) => ({
      ...s,
      customerId: null,
      booking: null,
    }));
    return;
  }
  // fetch current booking
  const resp = await getCurrentBooking(token, id);
  if (resp.success) {
      if (resp?.data?.EndDate) {
          const matches = resp.data.EndDate.match(/\/Date\((\d+)([-+]\d{4})\)\//);
          if (matches) {
              const timestamp = parseInt(matches[1]);
              const offset = matches[2];
              let date = new Date(timestamp);
              
              // Store the timestamp for the countdown timer
              resp.data.EndDateTimestamp = date.getTime();
              
              // Format the date for display
              resp.data.EndDate = date.toLocaleString('fr-CA', {
                  timeZone: 'America/New_York',
                  dateStyle: 'medium',
                  timeStyle: 'short'
              });
          }
      }

    bookingState.update((s) => ({
      ...s,
      customerId: id,
      booking: resp?.data,
    }));
  } else {
    // no booking found
    bookingState.update((s) => ({
      ...s,
      customerId: id,
      booking: null,
    }));
  }
}

export async function cancelBooking() {
    let { token, booking } = get(bookingState);
    if (!booking) {
        return;
    }
    if (!token) {
        return;
    }

    if (typeof window.plausible === 'function') {
        window.plausible('Cancel Booking Attempt', {
            props: { carId: booking.CarNo }
        });
    }

    const resp = await apiCancelBooking(token, booking.RentalId);
    if (resp.success) {
        bookingState.update((s) => ({
            ...s,
            booking: null,
        }));
        
        if (typeof window.plausible === 'function') {
            window.plausible('Cancel Booking Success', {
                props: { carId: booking.CarNo }
            });
        }
    } else {
        if (typeof window.plausible === 'function') {
            window.plausible('Cancel Booking Failed', {
                props: { 
                    carId: booking.CarNo,
                    error: resp.message 
                }
            });
        }
    }
}

export async function bookCarAndRefresh(carId) {
  let currentVal;
  bookingState.update((s) => (currentVal = s));
  const { token, customerId } = currentVal;

  if (!token) {
    return { success: false, message: "No token" };
  }

  // Book the car
  const resp = await bookCar(carId, token, customerId);
  if (resp.success) {
    // once booked, refresh booking
    await refreshBooking();
  }
  return resp;
}
